module.exports = __webpack_public_path__ + "img/container-1-v.8f4b6789.png";